'use client';

import Link from 'next/link';
import type { CTABlock } from '@impact/types';

interface Props {
  block: CTABlock;
  editing?: boolean;
}

/**
 * Centered card variant: floating card with shadow, centered content
 */
export function CTACenteredCard({ block, editing }: Props) {
  const { title, subtitle, buttonText, buttonUrl, buttonStyle = 'primary' } = block.data;

  const buttonClasses = {
    primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
    outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground',
  };

  return (
    <div className="my-12 flex justify-center px-4">
      <div className="w-full max-w-lg rounded-2xl border border-border bg-background shadow-xl p-10 text-center">
        <h2
          className="text-2xl md:text-3xl font-bold text-foreground"
          {...(editing ? { 'data-editable': 'data.title' } : {})}
        >
          {title}
        </h2>
        {subtitle ? (
          <p
            className="mt-3 text-base text-muted-foreground"
            {...(editing ? { 'data-editable': 'data.subtitle' } : {})}
          >
            {subtitle}
          </p>
        ) : null}
        <Link
          href={editing ? '#' : buttonUrl}
          onClick={editing ? (e) => e.preventDefault() : undefined}
          className={`mt-6 inline-block px-8 py-3 rounded-full font-semibold transition-colors ${buttonClasses[buttonStyle]}`}
        >
          <span {...(editing ? { 'data-editable': 'data.buttonText' } : {})}>{buttonText}</span>
        </Link>
      </div>
    </div>
  );
}
